// Voltar ao mesmo lugar depois de uma troca que remonta as telas (texto 07 A4/B1).
// Trocar o modo, o tema, a cor de destaque ou o tamanho do texto remonta o app inteiro (app/_layout.tsx, "key").
// Quem aplica pede para retomar; a barra de abas volta para Ajustes e Ajustes reabre a mesma página.
// Vale só por alguns segundos, para nunca sobrar um pedido velho.

const VALIDADE = 5000;
let pedido: { pilha: string[]; em: number; ir: boolean; pilhaPendente: boolean } | null = null;
const valido = () => !!pedido && Date.now() - pedido.em < VALIDADE;

/** Pede para, depois da remontagem, voltar a Ajustes com estas páginas abertas (ex.: ['aparencia']). */
export function pedirRetomar(pilha: string[]) { pedido = { pilha, em: Date.now(), ir: true, pilhaPendente: true }; }

/** A barra de abas pergunta (uma vez) se deve ir para Ajustes. */
export function tomarIrAjustes(): boolean {
  if (!valido() || !pedido!.ir) return false;
  pedido!.ir = false;
  return true;
}

/** Ajustes pega (uma vez) as páginas a reabrir. */
export function tomarPilha(): string[] | null {
  if (!valido() || !pedido!.pilhaPendente) return null;
  pedido!.pilhaPendente = false;
  return pedido!.pilha;
}
